import React from 'react';
import './tableCheckbox.css';

const CheckBoxCell = ({
  value,
  row,
  selectRow,
  selectAll,
  deselectAll,
  selectedIds,
  dataCount,
  totalDataCount,
  handleRowSelection,
}) => {
  const isSelectAll = value === undefined;
  
  const onClick = (e) => {
    if (isSelectAll) {
      if (dataCount < totalDataCount) {
        // Select/deselect only displayed data
        if (Object.keys(selectedIds).length >= dataCount) {
          deselectAll();
        } else {
          selectAll();
        }
      } else {
        // Handle select/deselect for all data
        if (Object.keys(selectedIds).length === totalDataCount) {
          deselectAll();
        } else {
          selectAll();
        }
      }
    } else {
      // Pass the current selection state
      const isCurrentlySelected = selectedIds[row.original.id] === 1;
      selectRow(e, row, isCurrentlySelected);
    }
  };

  // Dummy onChange function to suppress the warning
  const dummyOnChange = () => {};

  return (
    <input
      className="tableCheckbox"
      type='checkbox'
      title="Checkbox"
      // eslint-disable-next-line react/jsx-props-no-spreading
      checked={
        !isSelectAll
          ? selectedIds[row.original.id] === 1
          : Object.keys(selectedIds).length === totalDataCount 
      }
      onClick={onClick}
      onChange={dummyOnChange} // Suppress the warning by providing a dummy onChange
    />
  )
};

export default CheckBoxCell;
